app.directive('facebookMessengerCheckbox', [
  'mainConfig',
  'benchatService',
  'featureService',
  '$timeout',
  '$q',
  function (mainConfig, benchatService, featureService, $timeout, $q) {
    return {
      restrict: 'A',
      templateUrl:
        '/themes/v1/default/views/templates.facebook-messenger-checkbox.html',
      scope: {
        benchatConfig: '=',
        benchatChannel: '=',
        customerId: '@',
        orderId: '@',
        sessionId: '@',
        topicStr: '@topics',
      },
      link: function (scope, element, attrs) {
        scope.featureService = featureService;
        scope.topics = scope.topicStr.split(',');
      },
    };
  },
]);
